import { useEffect, useRef } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

/**
 * Remise en haut de page à chaque navigation (retour testeurs, remarque 5),
 * gérée globalement au niveau du routeur plutôt que page par page.
 *
 * - Nouvelle route (PUSH/REPLACE, ex. clic sur un lien) → repart en haut.
 * - Même route, seuls les paramètres de recherche changent (ex. filtre,
 *   pagination) → position conservée.
 * - Navigation POP (retour/avance navigateur) → position conservée (laisse
 *   le comportement natif du navigateur, jamais forcée en haut).
 */
export const ScrollToTop = () => {
  const { pathname } = useLocation();
  const navigationType = useNavigationType();
  const prevPathname = useRef(pathname);

  useEffect(() => {
    const pathnameChanged = prevPathname.current !== pathname;
    prevPathname.current = pathname;
    if (pathnameChanged && navigationType !== 'POP') {
      window.scrollTo(0, 0);
    }
  }, [pathname, navigationType]);

  return null;
};
